import { render } from "./ShowmoreItems.vue?vue&type=template&id=45ea7302"
import script from "./ShowmoreItems.vue?vue&type=script&lang=js"
export * from "./ShowmoreItems.vue?vue&type=script&lang=js"
script.render = render

export default script